import { Link } from 'react-router-dom';

const services = [
  'Drain Cleaning',
  'Sewer Line Repair',
  'Hydro Jetting',
  'Rooter Service',
  'Sewer Liners (CIPP)',
  'Plumbing Repairs',
  'Tankless Water Heaters',
  'Commercial Plumbing',
  'Water Heater Service',
];

const serviceAreas = [
  'San Bernardino',
  'Riverside',
  'Fontana',
  'Moreno Valley',
  'Rancho Cucamonga',
  'Rialto',
  'Redlands',
  'Highland',
  'Colton',
  'Loma Linda',
  'Upland',
];

const Footer = () => (
  <footer className="bg-navy-dark text-white relative overflow-hidden">
    {/* Top gold CTA bar */}
    <div className="relative bg-gold py-5">
      <div className="max-w-[1280px] mx-auto px-8 flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-navy/50 text-[10px] tracking-[0.2em] uppercase font-sans mb-1">San Bernardino&apos;s Most Trusted</div>
          <span className="font-serif text-navy font-bold text-xl leading-tight">
            Ready for Premium Drain &amp; Sewer Service?
          </span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="mailto:Drainandsewerpro@gmail.com"
            className="flex items-center gap-2.5 bg-navy text-white font-semibold text-[13px] px-6 py-3 rounded cursor-pointer whitespace-nowrap hover:bg-navy-light transition-colors uppercase tracking-wide"
          >
            <i className="ri-mail-line" />
            Email Us
          </a>
          <Link
            to="/location"
            className="flex items-center gap-2.5 bg-white text-navy font-semibold text-[13px] px-6 py-3 rounded cursor-pointer whitespace-nowrap hover:bg-cream transition-colors uppercase tracking-wide"
          >
            Free Estimate
          </Link>
        </div>
      </div>
    </div>

    {/* Main footer content */}
    <div className="relative z-10">
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(201,168,76,1) 0%, transparent 60%)' }} />
      <div className="max-w-[1280px] mx-auto px-8 py-20 grid grid-cols-1 md:grid-cols-4 gap-14">

        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
              <img
                src="https://d3p2r6ofnvoe67.cloudfront.net/fit-in/198x198/filters:strip_exif()/filters:no_upscale()/filters:format(webp)/media/fbbe76ba-f692-40ed-9f89-bcbaa7785d8a.png"
                alt="Drain & Sewer Pro Logo"
                className="w-10 h-10 object-contain"
              />
            </div>
            <div>
              <div className="font-serif font-bold text-[14px] tracking-[0.08em] text-white leading-tight">
                DRAIN &amp; SEWER PRO
              </div>
              <div className="text-gold/60 text-[10px] tracking-[0.2em] uppercase font-sans">San Bernardino, CA</div>
            </div>
          </div>
          <p className="text-white/40 text-[13px] leading-relaxed mb-8 font-sans">
            San Bernardino&apos;s premier licensed drain and sewer specialists. Trusted by homeowners and businesses throughout the Inland Empire for over a decade.
          </p>
          <div className="flex items-center gap-2.5 mb-6">
            {[
              { icon: 'ri-facebook-fill', href: 'https://www.facebook.com' },
              { icon: 'ri-google-fill', href: 'https://www.google.com' },
            ].map(s => (
              <a
                key={s.icon}
                href={s.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded border border-white/10 text-white/35 hover:text-gold hover:border-gold/40 transition-colors cursor-pointer"
              >
                <i className={`${s.icon} text-sm`} />
              </a>
            ))}
          </div>
          {/* License badge */}
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/8 rounded-lg px-4 py-2.5">
            <i className="ri-shield-check-fill text-gold text-sm" />
            <span className="text-white/45 text-[11px] font-sans">CA Licensed &amp; Insured</span>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-semibold text-[11px] tracking-[0.25em] uppercase mb-6 font-sans border-b border-white/8 pb-4">
            <a href="/services" className="hover:text-gold transition-colors cursor-pointer">Our Services</a>
          </h4>
          <ul className="space-y-3">
            {services.map(s => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-white/40 text-[13px] hover:text-gold transition-colors cursor-pointer flex items-center gap-2.5 group"
                >
                  <span className="w-1 h-1 bg-gold/40 rounded-full flex-shrink-0 group-hover:bg-gold transition-colors" />
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Service Areas */}
        <div>
          <h4 className="text-white font-semibold text-[11px] tracking-[0.25em] uppercase mb-6 font-sans border-b border-white/8 pb-4">
            <a href="/location" className="hover:text-gold transition-colors cursor-pointer">Service Areas</a>
          </h4>
          <ul className="space-y-3">
            {serviceAreas.map(area => (
              <li key={area}>
                <Link
                  to="/location"
                  className="text-white/40 text-[13px] hover:text-gold transition-colors cursor-pointer flex items-center gap-2.5 group"
                >
                  <span className="w-1 h-1 bg-gold/40 rounded-full flex-shrink-0 group-hover:bg-gold transition-colors" />
                  {area}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold text-[11px] tracking-[0.25em] uppercase mb-6 font-sans border-b border-white/8 pb-4">
            Contact &amp; Hours
          </h4>
          <ul className="space-y-5">
            <li className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/5 rounded-lg text-gold flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-sm" />
              </div>
              <div>
                <div className="text-white/60 text-[13px] font-sans leading-relaxed">
                  4892 North Pershing Avenue<br />
                  San Bernardino, CA 92407<br />
                  <span className="text-white/30 text-[12px]">Serving the Inland Empire</span>
                </div>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/5 rounded-lg text-gold flex-shrink-0">
                <i className="ri-mail-line text-sm" />
              </div>
              <a href="mailto:Drainandsewerpro@gmail.com" className="text-white/60 text-[13px] hover:text-gold transition-colors cursor-pointer font-sans break-all">
                Drainandsewerpro@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/5 rounded-lg text-gold flex-shrink-0">
                <i className="ri-time-line text-sm" />
              </div>
              <div>
                <div className="text-white/60 text-[13px] font-sans">24/7 Emergency Service</div>
                <div className="text-white/25 text-[11px] font-sans">Always Available</div>
              </div>
            </li>
          </ul>

          <div className="mt-8">
            <Link
              to="/location"
              className="block text-center bg-gold hover:bg-gold-mid text-white font-semibold text-[13px] py-3.5 rounded transition-colors cursor-pointer whitespace-nowrap tracking-widest uppercase"
            >
              Schedule Service
            </Link>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-white/6">
      <div className="max-w-[1280px] mx-auto px-8 py-5 flex flex-wrap items-center justify-between gap-3">
        <p className="text-white/20 text-[12px] font-sans">
          &copy; {new Date().getFullYear()} Drain and Sewer Pro. All Rights Reserved. 4892 N. Pershing Ave, San Bernardino, CA 92407.
        </p>
        <div className="flex items-center gap-6">
          <Link to="/" className="text-white/20 text-[12px] hover:text-white/40 transition-colors cursor-pointer font-sans">
            Privacy Policy
          </Link>
          <Link to="/" className="text-white/20 text-[12px] hover:text-white/40 transition-colors cursor-pointer font-sans">
            Terms of Service
          </Link>
          <Link to="/location" className="text-white/20 text-[12px] hover:text-white/40 transition-colors cursor-pointer font-sans">
            Sitemap
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
